"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getApplicationInsightsReactPlugin = void 0;
var _applicationinsightsReactJs = require("@microsoft/applicationinsights-react-js");
var _ApplicationInsights = require("./ApplicationInsights");
var _isServerApplicationInsightsClient = require("./isServerApplicationInsightsClient");
var getApplicationInsightsReactPlugin = function() {
    var _ai_config_extensions;
    var ai = _ApplicationInsights.ApplicationInsights.get();
    if ((0, _isServerApplicationInsightsClient.isServerApplicationInsightsClient)(ai)) {
        throw new Error('There is no react plugin on server for application insights');
    }
    var plugin = (_ai_config_extensions = ai.config.extensions) === null || _ai_config_extensions === void 0 ? void 0 : _ai_config_extensions.find(function(extension) {
        return extension instanceof _applicationinsightsReactJs.ReactPlugin;
    });
    return plugin;
};
exports.getApplicationInsightsReactPlugin = getApplicationInsightsReactPlugin; //# sourceMappingURL=getApplicationInsightsReactPlugin.js.map
